module.exports = __webpack_public_path__ + "static/img/Cooperation_1.e6c2b473.jpg";